<template>
  <span
    class="tooltip-icon"
    :class="shade"
    v-b-tooltip.hover.topright
    :title="title"
    >?</span
  >
</template>
<script>
export default {
  props: {
    title: String,
    shade: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss">
.tooltip-icon {
  height: 1.2rem;
  width: 1.2rem;
  border: 1px solid $dc-label-color;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  margin-left: 0.4rem;
  margin-right: 0.4rem;

  &.dark {
    font-weight: 200;
    color: $noble-blue-500;
    background-color: $drip-bg;
  }
}
.tooltip-inner {
  max-width: 350px;
}
</style>
